import React, {Component } from 'react'
import {Col} from 'react-bootstrap'
import './SectionBlock.css'

class SelectionBlock extends Component {
    constructor(props) {
        super(props);
        console.log("key for sectionBlock component ", props.id );
    }
    

    render() {
        const detailMap = {
            intuition: {
                number: 1,
                heading: 'Intuition',
                pic: './yodaSq.png',
                color: '#90ee90'
            },
            analysis: {
                number: 2,
                heading: 'Analysis',
                pic: './sigma4.png',
                color: '#b366ff'
            },
            songAndCode: {
                number: 3,
                heading: 'Song & Code',
                pic: './noteSq3.png',
                color: 'orange'
            }
        };

        const buttonStyle = {
            backgroundColor: detailMap[this.props.id]['color'],
            paddingTop: '1px',
            marginTop: '30px'
        };


        return (
            <Col xs={4}>
                <div 
                  className="vbtn" 
                  style={buttonStyle}
                  onClick={this.props.handler.bind(null, this.props.id)}
                  >
                    <h3>{detailMap[this.props.id]['number']}</h3>
                    <img 
                        className="tablet_image" 
                        src={detailMap[this.props.id]['pic']} 
                        alt={this.props.id} />
                    <div style={{"margin": "0 auto", "textAlign": "center",}}>
                        <p className='blockHeader' style={{"fontWeight": "500",}}>
                            {detailMap[this.props.id]['heading']}
                        </p>
                    </div>
                    <div className="button-wrapper" ref="vid2">
                        <a className="btn btn-secondary" 
                            onClick={this.props.handler.bind(null, this.props.id)}
                            role="button">Play &raquo;</a>
                    </div>
                </div>
            </Col>
        )
    }
}
export default SelectionBlock


// WEBPACK FOOTER //
// ./src/SectionBlock/SectionBlock.js